import { FC } from 'react';

import { useAppSelector } from '@redux/store';
import { selectHasPermissions } from '@redux/Roles/roles.selectors';
import { TShowComponentProps } from './constants/interfaces';

const ShowComponentIfUserHasPermission: FC<TShowComponentProps> = ({
  overridePermissions = false,
  allowAny = false,
  permissionRef,
  children,
}) => {
  const hasPermission = useAppSelector((state) =>
    selectHasPermissions(state, permissionRef, allowAny)
  );

  try {
    if (overridePermissions) {
      return null;
    }
    return hasPermission ? children : null;
  } catch (err) {
    console.warn(
      'ShowComponentIfUserHasPermission failed using:',
      { overridePermissions, allowAny, permissionRef },
      '\n',
      'Pass in permissionRef = ["resource", "subject", "action"] for a single permission \n',
      'or pass permissionRef = [["resource", "subject", "action"]["resource", "subject", "action"]] for multiple permissions.'
    );
    return null;
  }
};

export default ShowComponentIfUserHasPermission;
